export default function ContainerStats({ logServices, containerLogs, logStreamStatus, activeLogTab, onActiveLogTabChange }) {
  return (
    <div className="mt-5 flex flex-wrap items-end gap-4">
      <label className="flex w-full max-w-xs flex-col gap-1.5 text-[10px] font-black uppercase tracking-wider text-slate-500">
        Service
        <select
          value={activeLogTab}
          onChange={(e) => onActiveLogTabChange(e.target.value)}
          className="w-full max-w-xs rounded-xl border border-slate-300 bg-slate-900/55 px-3 py-2.5 text-sm font-semibold text-slate-800 shadow-sm"
        >
          {logServices.map((svc) => {
            const n = (containerLogs[svc] || []).length;
            const st = logStreamStatus[svc];
            return (
              <option key={svc} value={svc}>
                {svc} · {n} lines · {st === 'live' ? 'live' : st === 'reconnecting' ? 'reconnecting' : 'idle'}
              </option>
            );
          })}
        </select>
      </label>
    </div>
  );
}
